import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';

import MonitorsList from './MonitorsList.js';
import RosterPanel from '../../components/Roster/RosterPanel.js';

const Monitors = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Tabs value={tab} onChange={(_, value: number) => setTab(value)} sx={{ mb: 2 }}>
        <Tab label="Monitors" />
        <Tab label="Roster" />
      </Tabs>
      {tab === 0 && <MonitorsList />}
      {tab === 1 && <RosterPanel />}
    </Box>
  );
};

export default Monitors;
